import styled from "styled-components";

export const StyledButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;
